module.exports = __webpack_public_path__ + "img/CtrlRoom_wifi_on.ede46422.png";